var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12249",
    "data-name": "Group 12249",
    transform: "translate(-905 -702)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148723",
    "data-name": "Rectangle 148723",
    width: 24,
    height: 24,
    transform: "translate(905 702)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-facebook",
    d: "M17,3H7A4,4,0,0,0,3,7V17a4,4,0,0,0,4,4h5.621V14.039H10.278V11.314h2.343v-2a3.275,3.275,0,0,1,3.5-3.591,20.018,20.018,0,0,1,2.092.105v2.43H16.78c-1.13,0-1.35.534-1.35,1.322V11.31h2.7l-.351,2.725H15.414V21H17a4,4,0,0,0,4-4V7A4,4,0,0,0,17,3Z",
    transform: "translate(905 702)",
    fill: "#4267b2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0c526c347bd60863b3608f6bbea2309a.svg";
export { ForwardRef as ReactComponent };